import { useState, type FormEvent } from 'react';
import { Link } from 'react-router-dom';
import AuthOmhulsel, { Etiket } from '../components/AuthOmhulsel';
import { Foutmelding } from '../components/ui';
import { useAuth } from '../lib/auth';

export default function Login() {
  const { signIn } = useAuth();
  const [email, setEmail] = useState('');
  const [wachtwoord, setWachtwoord] = useState('');
  const [fout, setFout] = useState<string | null>(null);
  const [bezig, setBezig] = useState(false);

  async function verstuur(e: FormEvent) {
    e.preventDefault();
    if (!email || !wachtwoord) {
      setFout('Vul je e-mailadres en wachtwoord in.');
      return;
    }
    setBezig(true);
    setFout(null);
    try {
      await signIn(email.trim(), wachtwoord);
    } catch (err) {
      setFout(err instanceof Error ? err.message : 'Inloggen mislukte.');
      setBezig(false);
    }
  }

  return (
    <AuthOmhulsel>
      <h1 className="font-display text-[32px] leading-tight">Inloggen</h1>
      <p className="mt-1 text-sm text-krijt-600">Voer je e-mailadres en wachtwoord in.</p>

      <form onSubmit={verstuur} className="mt-7">
        {fout ? <Foutmelding>{fout}</Foutmelding> : null}

        <label className="mb-4 block">
          <Etiket tekst="E-mailadres" verplicht />
          <input
            type="email"
            className="veld"
            value={email}
            autoComplete="username"
            autoCapitalize="off"
            spellCheck={false}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>

        <label className="mb-5 block">
          <Etiket tekst="Wachtwoord" verplicht />
          <input
            type="password"
            className="veld"
            value={wachtwoord}
            autoComplete="current-password"
            onChange={(e) => setWachtwoord(e.target.value)}
          />
        </label>

        <button
          type="submit"
          disabled={bezig}
          className="w-full rounded-full bg-veld-800 py-2.5 text-sm font-semibold text-white transition hover:bg-veld-900 disabled:opacity-50"
        >
          {bezig ? 'Bezig…' : 'Inloggen'}
        </button>

        <p className="mt-5 text-sm text-krijt-600">
          Nog geen account?{' '}
          <Link to="/aanmelden" className="font-medium text-veld-800 underline underline-offset-2">
            Maak er een aan
          </Link>
        </p>
      </form>
    </AuthOmhulsel>
  );
}
